export const AvailableAssetsName = "available_assets";
export const TypesOfInvestmentExperience = "types_of_investment_experience";
export const AvgNetProfitForMonth = "avg_net_profit_for_month";

export const InvestmentExperienceName = "investments_experience";
export const InvestmentExperienceAllowValues = ["a"];

export const CrowdfundingExperienceValue = "f";

export const AlwaysVisibleQuestions = [AvailableAssetsName, AvgNetProfitForMonth, InvestmentExperienceName];